import React, { useMemo } from 'react';
import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  TextField,
} from '@mui/material';
import { ColumnDirective, ColumnsDirective, Filter, GridComponent, Group } from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { useAllUsers } from 'context/AllUserDataContext';
import useStockTransactionsForm from '../CustomHooks/useStockTransactionsForm';
import ViewStockTransactions from './ViewStockTransactions';
import useManagingStoresController from '../CustomHooks/useManagingStoresController';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';

const AddStockTransactions = ({ viewFormDialog, handleAddDialogClose, currentData, stockTransaction, handleConsume }) => {
  const { allUsers } = useAllUsers();
  const { transactionData, handleInput, handleSubmit } = useStockTransactionsForm(currentData, handleConsume);
  return (
    <div>
      <Dialog open={viewFormDialog} onClose={handleAddDialogClose} maxWidth="xl" fullWidth scroll="paper">
        <DialogTitle>Manage Stock Transactions</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleAddDialogClose}
          sx={theme => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}>
          <CloseIcon />
        </IconButton>

        <form
          onSubmit={handleSubmit}
          onKeyDown={e => {
            if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
              e.preventDefault();
            }
          }}>
          <DialogContent
            dividers
            sx={{
              overflow: 'auto',
            }}>
            <Box sx={{ marginBottom: 2 }}>
              <SectionAccordians header={'View Transactions'}>
                <ViewStockTransactions stockTransaction={stockTransaction} />
              </SectionAccordians>
            </Box>
            <SectionAccordians header={'Create New Stock Transaction'}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 2,
                  marginBottom: 2,
                }}>
                {/* Employee */}
                <Box sx={{ flex: 1 }}>
                  <InputLabel sx={{ fontSize: '0.8rem', color: 'black', marginBottom: '4px' }}>Employee</InputLabel>
                  <Autocomplete
                    size="small"
                    options={allUsers}
                    onChange={(e, value) => handleInput('recordEnteredBy', value.email)}
                    value={allUsers.find(user => user.email === transactionData.recordEnteredBy) || null}
                    renderInput={params => <TextField {...params} placeholder="Select Employee" size="small" fullWidth />}
                    getOptionLabel={option => option.email || ''}
                  />
                </Box>

                {/* Department */}
                <Box sx={{ flex: 1 }}>
                  <InputLabel sx={{ fontSize: '0.8rem', color: 'black', marginBottom: '4px' }}>Department</InputLabel>
                  <TextField
                    type="text"
                    placeholder="Enter department name"
                    size="small"
                    fullWidth
                    onChange={e => handleInput('departmentOrMachine', e.target.value)}
                    value={transactionData.departmentOrMachine}
                  />
                </Box>

                {/* Quantity */}
                <Box sx={{ flex: 1 }}>
                  <InputLabel sx={{ fontSize: '0.8rem', color: 'black', marginBottom: '4px' }}>Quantity Consumed</InputLabel>
                  <TextField
                    type="number"
                    placeholder="5"
                    size="small"
                    fullWidth
                    onChange={e => handleInput('quantity', e.target.value)}
                    value={transactionData.quantity}
                  />
                </Box>
              </Box>

              {/* Notes */}
              <Box>
                <InputLabel sx={{ fontSize: '0.8rem', color: 'black', marginBottom: '4px' }}>Notes</InputLabel>
                <TextField multiline rows={4} size="small" fullWidth placeholder="Enter notes..." />
              </Box>
            </SectionAccordians>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" type="submit">
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default AddStockTransactions;
